"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS: true
};
Object.defineProperty(exports, "DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS", {
  enumerable: true,
  get: function () {
    return _constants.DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS;
  }
});
var _useAnalyticsSignalEventListener = require("./useAnalyticsSignalEventListener");
Object.keys(_useAnalyticsSignalEventListener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useAnalyticsSignalEventListener[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useAnalyticsSignalEventListener[key];
    }
  });
});
var _constants = require("./constants");
